<template>
  <div class="StaffManage-list">
    <GlobalInfoBar
      title="添加礼包"
      content="添加礼包内容，设置领取礼包内容及礼品使用规则"
    />
    <GlobalChunk>
      <div>
        <el-form
          class="form-c"
          :model="formData"
          :rules="formRules"
          ref="ruleForm"
          label-width="165px"
        >
          <el-form-item label="礼包名称：" prop="giftPackName">
            <el-input
              size="small"
              v-model="formData.giftPackName"
              placeholder="如“线上回收专享福利”，最多可输入10个字"
              maxlength="10"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="礼包有效期："
            class="expire-time"
            prop="expireTime"
          >
            <div class="flex">
              <span style="color:#666666;margin-right:10px">截止</span>
              <el-date-picker
                size="small"
                v-model="formData.expireTime"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
              <span style="margin-left:5px;color:#666666;">23:59:59</span>
              <span style="color:#666666;margin-left:5px">前回收成功，礼包可用</span>
            </div>
          </el-form-item>
          <el-form-item label="赠送订单类型：" required>
            <el-radio-group v-model="formData.configWay">
              <el-radio label="01">仅到店回收可用</el-radio>
              <el-radio label="02">到店及上门回收均可用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="赠品设置：" required>
            <div class="flex flex-jb" style="color: #FF687B;">
              <span
                >获取门槛金额为订单实际金额，包含本机估价和限时红包金额，若回收下单以订单实收价计算。</span
              >
              <el-button
                size="small"
                type="primary"
                icon="el-icon-plus"
                @click="addGift"
                >添加赠品</el-button
              >
            </div>
            <GlobalTable
              class="form-table"
              ref="GlobalTable"
              v-loading="tableLoading"
              :columns="tableColumns"
              :data="dataList"
              :isPagination="false"
            >
              <el-table-column label="赠品类型" slot="giftType" align="center">
                <template slot-scope="{ row }">
                  {{ row.giftType == "01" ? "换新补贴" : "回收赠礼" }}
                </template>
              </el-table-column>
              <el-table-column
                label="赠品价值/最高补贴"
                slot="giftPrice"
                align="center"
              >
                <template slot-scope="{ row }">
                  {{ row.giftPrice || 0 }}元
                </template>
              </el-table-column>
              <el-table-column
                label="赠品是否有门槛"
                slot="giveType"
                align="center"
              >
                <template slot-scope="{ row }">
                  <el-select v-model.trim="row.giveType" @change="setGiveType($event,row)" size="mini">
                    <el-option label="满足金额赠送" value="01"> </el-option>
                    <el-option label="无门槛(可叠加)" value="02"> </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="设置赠送门槛(按订单实际金额)"
                slot="threshold"
                align="center"
              >
                <template slot-scope="{ row }">
                  <span v-if="row.giveType == '02'">--</span>
                  <template class="flex" v-else>
                    <el-input
                      size="mini"
                      v-model.trim="row.threshold"
                      placeholder="金额"
                      @input="setThreshold($event,row)"
                    ></el-input>
                    <span style="margin-left:10px">元</span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column
                width="250"
                label="操作"
                slot="operation"
                align="center"
              >
                <template slot-scope="{ row }">
                  <el-button
                    size="mini"
                    type="danger"
                    round
                    @click="delOnGift(row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </GlobalTable>
          </el-form-item>
          <el-form-item label="参加换新活动门店是否需要填写新机串号：" required v-if="isShowFillIn">
            <el-radio-group
              v-model="formData.renewMustNewImei"
              style="margin-top: 35px;"
            >
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="参加换新活动门店是否需要填写购买凭证：" required v-if="isShowFillIn">
            <el-radio-group
              v-model="formData.renewMustBuyProof"
              style="margin-top: 35px;"
            >
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button @click="goBack">取消</el-button>
            <el-button type="primary" @click="sureAddGift">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
      <DialogTbale
        :show="giftListDialogShow"
        :loading="giftListLoading"
        title="设置赠品"
        :columns="giftListColumns"
        isSelection
        :data="giftList"
        ref="multipleTable"
        :currentPage="dialogPage.pageNum"
        :total="dialogPage.total"
        :pageSize="dialogPage.pageSize"
        :width="800"
        @onClose="giftListDialogClosed"
        @handleCurrentChange="currentChangeDialog"
        @handleSelect="handleSelect"
      >
        <div>
          <el-button type="text" style="text-decoration: underline;" @click="goGiftManage">进入赠品管理</el-button>
        </div>
        <el-table-column label="赠品类型" slot="giftType" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.giftType == "01" ? "换新补贴" : "回收赠礼" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="赠品价值/最高补贴"
          slot="giftPrice"
          align="center"
        >
          <template slot-scope="{ row }"> {{ row.giftPrice || 0 }}元 </template>
        </el-table-column>
        <div
          slot="tableFooter"
          class="flex flex-je"
          style="padding-bottom: 20px; box-sizing: border-box"
        >
          <el-button size="small" @click="giftListDialogClosed"
            >取 消</el-button
          >
          <el-button size="small" type="primary" :loading="btnLoading" @click="sureSelect"
            >确定</el-button
          >
        </div>
      </DialogTbale>
    </GlobalChunk>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      giftPackId: "",
      btnLoading: false,
      isShowFillIn: false,
      formData: {
        giftPackName: "",
        configWay: "01",
        expireTime: "",
        gifts: [],
        renewMustBuyProof: false,
        renewMustNewImei: false,
      },
      formRules: {
        giftPackName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入礼包名称",
          },
        ],
        expireTime: [
          {
            required: true,
            trigger: "change",
            message: "请选择截止日期",
          },
        ],
      },
      tableLoading: false,
      tableColumns: [
        { label: "赠品名称", prop: "giftName" },
        { slotName: "giftType" },
        { slotName: "giftPrice" },
        { slotName: "giveType" },
        { slotName: "threshold" },
        { slotName: "operation" },
      ],
      dataList: [],
      giftListDialogShow: false,
      giftListLoading: false,
      giftListColumns: [
        { label: "赠品名称", prop: "giftName" },
        { slotName: "giftType" },
        { slotName: "giftPrice" },
      ],
      giftList: [],
      dialogPage: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      ignoreIds: [],
      selectIgnoreIds: [],
      selectGiftList: [], //回显选择打钩
    };
  },
  created() {
    this.giftPackId = this.$route.query.id;
    if(this.giftPackId){
      _api.packInfo({giftPackId:this.giftPackId}).then(res => {
        if(res.code==1){
          console.log(res);
          this.formData.configWay = res.data.configWay
          this.formData.giftPackName = res.data.giftPackName
          this.formData.renewMustBuyProof = res.data.renewMustBuyProof
          this.formData.renewMustNewImei	 = res.data.renewMustNewImei
          this.formData.expireTime	 = res.data.expireTimeStamp
          this.dataList = res.data.gifts
        }
      })
    }
  },
  mounted() {},
  watch: {
    dataList(val){
      this.isShowFillIn = false
      val.forEach(item => {
        if(item.giftType == '01'){
          this.isShowFillIn = true
        }
      })
    }
  },
  methods: {
    // 添加赠品弹框
    addGift() {
      this.giftListDialogShow = true;
      this.ignoreIds = [];
      this.dataList.forEach((item) => {
        this.ignoreIds.push(item.id);
      });
      this.currentChangeDialog();
    },
    // 删除赠品
    delOnGift(row) {
      this.dataList.forEach((item, i) => {
        if (row.id == item.id) {
          this.dataList.splice(i, 1);
        }
      });
    },
    // 选择赠品弹框关闭
    giftListDialogClosed() {
      this.selectGiftList = [];
      this.giftListDialogShow = false;
      this.dialogPage.pageNum = 1;
    },
    // 赠品弹框列表翻页
    currentChangeDialog(val) {
      if (val) {
        this.dialogPage.pageNum = val;
      }
      let baseRequest = {
        ignoreIds: this.ignoreIds,
        pageNum: this.dialogPage.pageNum,
        pageSize: this.dialogPage.pageSize,
      };
      this.giftListLoading = true;
      _api.giftList(baseRequest).then((res) => {
        if (res.code == 1) {
          this.giftList = res.data.records;
          this.dialogPage.total = res.data.total;
          this.dialogPage.pageNum = res.data.current;

          this.storageArr = JSON.parse(JSON.stringify(res.data.records));
          this.dialogPage.total = res.data.total;
          let _rows = [];
          this.giftList.forEach((item) => {
            if (this.selectGiftList.some((ele) => ele.id == item.id)) {
              _rows.push(item);
            }
            return item;
          });
          this.toggleSelection(_rows);
          this.giftListLoading = false;
        }
      });
    },
    // 赠品多选
    handleSelect(e) {
      console.log(e);
      this.selectGiftList = this.selectGiftList.filter((item) => {
        return !this.giftList.some((ee) => ee.id == item.id);
      });
      let jsonArr = e;
      let newJson = this.selectGiftList; //盛放去重后数据的新数组
      for (let item1 of jsonArr) {
        //循环json数组对象的内容
        let flag = true; //建立标记，判断数据是否重复，true为不重复
        for (let item2 of newJson) {
          //循环新数组的内容
          if (item1.id == item2.id) {
            //让json数组对象的内容与新数组的内容作比较，相同的话，改变标记为false
            flag = false;
          }
        }
        if (flag) {
          //判断是否重复
          newJson.push(item1); //不重复的放入新数组。  新数组的内容会继续进行上边的循环。
        }
      }
      this.selectGiftList = newJson;
    },
    // 回显显示效果
    toggleSelection(rows) {
      Promise.resolve().then(() => {
        if (rows && rows.length) {
          rows.forEach((row) => {
            this.$refs.multipleTable.setSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    // 设置门槛金额
    setThreshold(val,row) {
      this.dataList.forEach(item => {
        if(item.id == row.id){
          item.threshold = val.replace(/[^[0-9]/g,'').replace(/^0[0-9]*/g, '')
        }
      })
      this.$forceUpdate();
    },
    // 设置是否无门槛
    setGiveType(val,row) {
      this.dataList.forEach(item => {
        if(item.id == row.id){
          item.giveType = val
        }
      })
      this.$forceUpdate();
    },
    // 确定选择
    sureSelect() {
      this.dataList.push(...this.selectGiftList);
      this.dataList.forEach((item) => {
        item.giveType = item.giveType || "01";
        item.threshold = item.threshold || "";
      });
      this.giftListDialogClosed();
    },
    // 确定添加礼包
    sureAddGift() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.formData.gifts = []
          let isThreshold = true
          let expireTime = moment(this.formData.expireTime).endOf('day').format("x")
          this.dataList.forEach(item => {
            if(item.giveType == '01' && !item.threshold){
              isThreshold = false
            }
            this.formData.gifts.push({
              giftId: item.id,
              giveType: item.giveType,
              threshold: item.threshold,
            })
          })
          if(!isThreshold){
            this.$message.error('有赠品未设置门槛，请填写。')
            return
          }
          let baseRequest = {
            id: this.giftPackId,
            expireTime,
            gifts: this.formData.gifts,
            giftPackName: this.formData.giftPackName,
            configWay: this.formData.configWay,
            renewMustBuyProof: this.formData.renewMustBuyProof,
            renewMustNewImei: this.formData.renewMustNewImei,
          }
          this.btnLoading = true
          _api.addPackUpdate(baseRequest).then(res=>{
            console.log(res)
            if(res.code===1){
              this.$message.success(res.msg)
              this.goBack()
            }
            this.btnLoading = false
          }).catch(()=> {
            this.btnLoading = false
          })
        } else {
          return false;
        }
      });
    },
    // 取消
    goBack() {
      this.$router.push("/OnlinreyService/giftBagManage");
    },
    // 去赠品管理
    goGiftManage() {
      let routeData = this.$router.resolve({
        path: "/OnlinreyService/giftManage"
      });
      window.open(routeData.href, "_blank");
    }
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  align-items: center;
}
.flex-jb {
  display: flex;
  justify-content: space-between;
}
.flex-as {
  display: flex;
  align-items: flex-start;
}
.flex-je {
  display: flex;
  justify-content: flex-end;
}
.form-c {
  /deep/.el-input {
    width: 350px !important;
  }
  .expire-time {
    /deep/.el-input {
      width: 130px !important;
    }
  }
  .form-table {
    /deep/.el-input {
      width: 140px !important;
    }
  }
}
</style>
